import { render, staticRenderFns } from "./ComponentAdminSectorColor.vue?vue&type=template&id=6b84fdce&"
import script from "./ComponentAdminSectorColor.vue?vue&type=script&lang=ts&"
export * from "./ComponentAdminSectorColor.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentAdminSectorColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports